import React, { useEffect, useState } from "react";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import "./sparePartsChartPage.css";

const SparePartsChartPage = () => {
  const [chart, setChart] = useState([]);
  const [loading, setLoading] = useState(true);

  const baseUrl = `https://api.generalhome.sa/api/Reports/GetMaintPartsRequestCounts`;

  useEffect(() => {
    const fetchInfo = async () => {
      try {
        const maintenanceAreaIdsString =
          localStorage.getItem("MaintenanceAreaIds");
        const maintainceAreaId = maintenanceAreaIdsString
          ? maintenanceAreaIdsString.split(",").map(Number)
          : [];
        const response = await axios.post(
          baseUrl,
          {
            maintenanceAreaIds: maintainceAreaId,
            MaintPartsNumber: 0, // Always fetch all parts
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        setChart(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchInfo();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <ClipLoader color="#00b1ff" size={50} />
      </div>
    );
  }

  // Calculate total requests for summary
  const totalRequests = chart.reduce(
    (total, item) => total + item.RequestCount,
    0
  );

  return (
    <div className="spare-parts-page">
      <div className="spare-parts-container">
        <div className="spare-parts-header">
          <h2>قطع الغيار</h2>
          <p>توزيع الطلبات حسب نوع القطعة</p>
        </div>

        <div className="spare-parts-grid">
          {chart.map((x, index) => (
            <div
              key={x.AirCondMaintPartId || index}
              className="spare-part-card"
            >
              <div className="spare-part-content">
                <div className="part-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" />
                  </svg>
                </div>
                <div className="spare-part-info">
                  <h3 className="spare-part-name">{x.AirCondMaintPartName}</h3>
                  <div className="spare-part-count">{x.RequestCount} طلب</div>
                </div>
              </div>
              <div className="progress-container">
                <div
                  className="progress-bar"
                  style={{
                    width: `${(x.RequestCount / totalRequests) * 100}%`,
                  }}
                ></div>
              </div>
            </div>
          ))}
        </div>

        <div className="spare-parts-summary">
          <div className="summary-item">
            <span className="summary-label">إجمالي أنواع القطع:</span>
            <span className="summary-value">{chart.length}</span>
          </div>
          <div className="summary-item">
            <span className="summary-label">إجمالي الطلبات:</span>
            <span className="summary-value">{totalRequests}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SparePartsChartPage;
